module.exports = __webpack_public_path__ + "static/media/CY.f7eb036f.png";